import React, { Component } from 'react'
import { CustomInput } from 'reactstrap'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { updateUser } from '../../../../redux/actions/conversations/user'
import { I18n } from 'react-redux-i18n'

import './styles.scss'

class PluginUserActivation extends Component {
  constructor(props) {
    super(props)

    this.state = { deactivating: false }

    this.userAct = bindActionCreators({ updateUser }, props.dispatch)

    this.toggleActivation = this.toggleActivation.bind(this)
    this.toggleState = this.toggleState.bind(this)
  }

  toggleActivation() {
    if (this.state.deactivating) return

    this.toggleState()

    const newUser = Object.assign({}, this.props.user)
    newUser.state = this.props.user.state !== 'list_deactivated' ? 'list_deactivated' : 'welcome_again'

    this.userAct.updateUser(newUser).finally(this.toggleState)
  }

  toggleState() {
    this.setState((prevState) => ({ deactivating: !prevState.deactivating }))
  }

  render() {
    const deactivatedUser = this.props.user.state === 'list_deactivated'
    return (
      <div className='plugin-card-enabled' onClick={this.toggleActivation}>
        <div className='switch-container'>
          <CustomInput
            onChange={this.toggleActivation}
            id='user.deactivate'
            type='switch'
            checked={!deactivatedUser}
          />
          <div className='title'>
            {I18n.t(deactivatedUser ? 'dashboard_reactivate-user' : 'dashboard_deactivate-user')}
          </div>
        </div>
      </div>
    )
  }
}

export default connect()(PluginUserActivation)
